import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LogoutActivateGuard } from './guards/logout-activate.guard';
import { LoginActivateGuard } from './guards/login-activate.guard';

const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./components/login/login.component').then(
        (m) => m.LoginComponent
      ),
    canActivate: [LogoutActivateGuard]
  },
  {
    path: 'register/:name/:email',
    loadComponent: () =>
      import('./components/register/register.component').then(
        (m) => m.RegisterComponent
      ),
    canActivate: [LogoutActivateGuard]
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./components/register/register.component').then(
        (m) => m.RegisterComponent
      ),
    canActivate: [LogoutActivateGuard]
  },
  {
    path: 'profile/done/:order',
    loadComponent: () =>
      import('./components/profile/profile.component').then(
        (m) => m.ProfileComponent
      ),
    canActivate: [LoginActivateGuard]
  },
  {
    path: 'profile/error/:order',
    loadComponent: () =>
      import('./components/profile/profile.component').then(
        (m) => m.ProfileComponent
      ),
    canActivate: [LoginActivateGuard]
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('./components/profile/profile.component').then(
        (m) => m.ProfileComponent
      ),
    canActivate: [LoginActivateGuard]
  },
  {
    path: 'teams',
    loadChildren: () =>
      import('./components/teams/teams-routing.module').then(
        (m) => m.TeamsRoutingModule
      ),
    canActivate: [LoginActivateGuard]
  },
  {
    path: 'doubts/:memberId',
    loadComponent: () =>
      import('./components/doubts/doubts.component').then(
        (m) => m.DoubtsComponent
      ),
    canActivate: [LoginActivateGuard]
  },
  {
    path: 'doubts',
    loadComponent: () =>
      import('./components/doubts/doubts.component').then(
        (m) => m.DoubtsComponent
      ),
    canActivate: [LoginActivateGuard]
  },
  {
    path: 'calendar',
    loadComponent: () =>
      import('./components/calendar/calendar.component').then(
        (m) => m.CalendarComponent
      ),
    canActivate: [LoginActivateGuard]
  },
  {
    path: 'payments',
    loadComponent: () =>
      import('./components/payments/payments.component').then(
        (m) => m.PaymentsComponent
      ),
    canActivate: [LoginActivateGuard]
  },
  {
    path: 'reviews',
    loadChildren: () =>
      import('./components/reviews/reviews-routing.module').then(
        (m) => m.ReviewsRoutingModule
      ),
    canActivate: [LoginActivateGuard]
  },
  {
    path: 'clients-control/:id',
    loadComponent: () =>
      import('./components/clients-control/clients-control.component').then(
        (m) => m.ClientsControlComponent
      ),
    canActivate: [LoginActivateGuard]
  },
  {
    path: 'info',
    loadComponent: () =>
      import('./components/info/info.component').then((m) => m.InfoComponent),
    canActivate: [LoginActivateGuard]
  },
  { path: '', pathMatch: 'full', redirectTo: 'teams' },
  { path: '**', redirectTo: 'teams' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
